import { intersperse } from "ramda";

export default intersperse((", " as unknown) as JSX.Element);
